<ng-container *ngIf="showDepositCurrency">
  <div class="overlay-no-data fund-account">
    <div class="notify-no-data">
      <div class="notify-text">
        Do you want to pay the Deposit
        <br> in {{getCurrencyPay.value.code}} or {{getCurrencyBuy.value.code}}?
      </div>
      <form [formGroup]="depositTickBox">
        <mat-radio-group formControlName="depositCurrency" class="ml-4">
          <mat-radio-button disableRipple value="{{getCurrencyPay.value.id}}">{{getCurrencyPay.value.code}}</mat-radio-button>
          <mat-radio-button disableRipple value="{{getCurrencyBuy.value.id}}">{{getCurrencyBuy.value.code}}</mat-radio-button>
        </mat-radio-group>

        <div class="d-flex mt-3 justify-content-center">
          <button class="btn btn-block btn-greengo mr-3" (click)="confirmDeposit()">OK</button>
          <button class="btn btn-block btn-greengo-o mt-0" (click)="cancelDeposit()">Cancel</button>
        </div>
      </form>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="overCutOffTime">
  <div class="overlay-no-data fund-account">
    <div class="notify-no-data">
      <div class="notify-text">
        The cut off time for same day trades has passed. Are you sure you want to continue?
      </div>
      <div class="d-flex mt-3 justify-content-center">
        <button class="btn btn-block btn-greengo mr-3" (click)="continue()">Yes</button>
        <button class="btn btn-block btn-greengo-o mt-0" (click)="cancel()">No</button>
      </div>
    </div>
  </div>
</ng-container>


<div [class.opacity-4]="showDepositCurrency || overCutOffTime">
  <div class="panel-title">
    Fund Your Account |
    <span class="panel-sub-title">How much would you like to buy?</span>
  </div>
  <div class="fund-account-screen client-dashboard-session">
    <div class="col-12 p-0">
      <form [formGroup]="fundAccountForm">

        <!-- Row 1 -->
        <div class="d-flex">
          <div class="col-12 col-md-8 p-0">
            <div class="top-text col-12">
              Buy
            </div>
            <div class="d-flex">
              <div class="col-5 currency currency-amount mat-border" [ngClass]="{
                'is-invalid': !getCurrencyBuy.valid && getCurrencyBuy.touched
              }">
                <mat-form-field class="mat-label-error">
                  <mat-select panelClass="custom-mat-panel" placeholder="Currency" formControlName="currencyBuy" (selectionChange)="changeCurrency()">
                    <mat-select-trigger>
                      <ng-container *ngIf="!getCurrencyBuy.value; else showCurrencyBuy">
                        -----
                      </ng-container>
                      <ng-template #showCurrencyBuy>
                        <div [innerHTML]="getCurrencyBuy.value | transformCurrency"></div>
                      </ng-template>
                    </mat-select-trigger>
                    <mat-option *ngFor="let currency of buyCurrencies" [value]="currency">
                      <span [class]="currency.code | flagIcon"></span>&nbsp;
                      <span>{{ currency.code }} </span>
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-7 amount currency-amount mat-border" [ngClass]="{
                'is-invalid': (!getAmountPay.value && !getAmountBuy.value) && getAmountBuy.touched && getAmountPay.touched
              }">
                <mat-form-field class="mat-label-error">
                  <input matInput formControlName="buyAmount" type="text" value="" autocomplete="off" npInputMask [options]="{
                                numeral: true,
                                numeralIntegerScale: 255
                              }" (blur)="changeAmount('buy')" id="buyAmountFocus" placeholder="Amount" />
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="col-4 pr-0 d-none d-md-block">
            <div class="d-flex top-text has-icon align-items-center">
              On this date
              <div class="img ml-auto">
                <img class="icon-info ml-auto" src="./assets/images/icon-png/icon-info-white.svg" alt="" />
                <span class="send-payment-tooltip tooltip-date tooltip-left">
                  {{brandName}} should receive your funds no later than the date specified.
                  <br>The account details for where to pay {{brandName}} are provided on your trade confirmation.
                  <br>This can be found in Trade History.
                </span>
              </div>
            </div>
            <div class="col-12 mat-border date-select" [ngClass]="{
              'is-invalid': !getValueDate.valid && getValueDate.touched,
              'img': !getCurrencyPay.value || !getCurrencyBuy.value
            }">
              <mat-form-field class="payment-date-value mat-label-error">
                <input readonly matInput [matDatepicker]="picker" (dateInput)="checkDateChange()" [max]="maxDate" [min]="minDate" formControlName="valueDate"
                  [matDatepickerFilter]="myFilter" placeholder="dd/mm/yyyy" (click)="togglePicker(picker)"/>
                <mat-datepicker-toggle matSuffix [for]="picker" [disabled]="!getCurrencyPay.value || !getCurrencyBuy.value"></mat-datepicker-toggle>
                <mat-datepicker panelClass="greengo" #picker></mat-datepicker>
              </mat-form-field>
              <span class="send-payment-tooltip tooltip-date tooltip-left" *ngIf="!getCurrencyPay.value || !getCurrencyBuy.value">
                Please select the buy and sell currencies before you select the date
              </span>
            </div>
          </div>
        </div>

        <div class="d-flex">
          <div class="text-center col-12 col-md-8 ">
            <img class="icon-arrow" (click)="switchValue()" src="./assets/images/icon-png/icon-arrow-updown.png" alt="" />
          </div>
        </div>

        <!-- Row 2 -->
        <div class="d-flex mg-b-20">
          <div class="col-12 col-md-8 p-0">
            <div class="top-text col-12">
              Pay with
            </div>
            <div class="d-flex">
              <div class="col-5 currency currency-amount mat-border" [ngClass]="{
          'is-invalid': !getCurrencyPay.valid && getCurrencyPay.touched}">

                <mat-form-field class="mat-label-error">
                  <mat-select panelClass="custom-mat-panel" formControlName="currencyPay" (selectionChange)="changeCurrency()" placeholder="Currency">
                    <mat-select-trigger>
                      <ng-container *ngIf="!getCurrencyPay.value; else showCurrencyPay">
                        -----
                      </ng-container>
                      <ng-template #showCurrencyPay>
                        <div [innerHTML]="getCurrencyPay.value | transformCurrency"></div>
                      </ng-template>
                    </mat-select-trigger>
                    <mat-option *ngFor="let currency of sellCurrencies" [value]="currency">
                      <span [class]="currency.code | flagIcon"></span>&nbsp;
                      <span>{{ currency.code }} </span>
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="col-7 amount currency-amount mat-border" [ngClass]="{
          'is-invalid': (!getAmountPay.value && !getAmountBuy.value) && getAmountBuy.touched && getAmountPay.touched}">
                <mat-form-field class="mat-label-error">
                  <input matInput formControlName="payAmount" type="text" value="" autocomplete="off" npInputMask [options]="{
                                numeral: true,
                                numeralIntegerScale: 255
                              }" (blur)="changeAmount('sell')" placeholder="Amount" />
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="col-4 pr-0 form-input-display d-none d-md-flex">
            <div class="d-flex top-text">
              Exchange Fee(%)
            </div>
            <div class="input-value">
              {{ exchangeFee | number: '1.2-2' }}
            </div>
          </div>
        </div>

        <div class="d-flex mg-b-20 d-md-none">
          <div class="col-6 p-0">
            <div class="d-flex top-text has-icon align-items-center">
              On this date
              <div class="img ml-auto">
                <img class="icon-info ml-auto" src="./assets/images/icon-png/icon-info-white.svg" alt="" />
                <span class="send-payment-tooltip tooltip-date tooltip-left">This is the date you wish to
                  <br>fund your account on.</span>
              </div>
            </div>
            <div class="col-12 mat-border date-select" [ngClass]="{
                    'is-invalid': !getValueDate.valid && getValueDate.touched,
                    'img': !getCurrencyPay.value || !getCurrencyBuy.value
                  }">
              <mat-form-field class="payment-date-value mat-label-error">
                <input readonly matInput [matDatepicker]="dpicker" (dateInput)="checkDateChange()" [max]="maxDate" [min]="minDate" formControlName="valueDate"
                  [matDatepickerFilter]="myFilter" placeholder="dd/mm/yyyy" (click)="togglePicker(dpicker)" />
                <mat-datepicker-toggle matSuffix [for]="dpicker" [disabled]="!getCurrencyPay.value || !getCurrencyBuy.value"></mat-datepicker-toggle>
                <mat-datepicker panelClass="greengo" #dpicker></mat-datepicker>
              </mat-form-field>
              <span class="send-payment-tooltip tooltip-date tooltip-left" *ngIf="!getCurrencyPay.value || !getCurrencyBuy.value">
                Please select the buy and sell currencies before you select the date
              </span>
            </div>
          </div>

          <div class="col-6 pr-0 form-input-display">
            <div class="d-flex top-text">
              Exchange Fee(%)
            </div>
            <div class="input-value exchange-fee-mobile">
              {{ exchangeFee | number: '1.2-2' }}
            </div>
          </div>
        </div>


        <!-- Row 3 -->
        <div class="d-flex mg-b-10">
          <div class="col-8 p-0">
            <div class="d-flex form-input-display live-rate mg-b-10" [ngClass]="{
              'rate-increase': rateChange === RATECHANGE.INCREASE,
              'rate-decrease': rateChange === RATECHANGE.DECREASE
            }">
              <div class="d-flex top-text col-12">
                Live Rate
              </div>
              <div class="input-value">
                {{ clientRate | number: '1.2-6' }}
              </div>
            </div>

            <div class="d-flex" *ngIf="registrationService.userRole !== userRoleEnum.ReadOnly">
              <button class="btn btn-block" [ngClass]="{
                  'btn-greengo': (getAmountBuy.value || getAmountPay.value) && getCurrencyPay.value && getCurrencyBuy.value && getValueDate.value && !isGettedRate,
                  'btn-inactive': (!getAmountBuy.value && !getAmountPay.value) || !getCurrencyPay.value || !getCurrencyBuy.value || !getValueDate.value || isGettedRate
                }" (click)="getRate()" npFocusOutClicked>
                Get Rate
              </button>
            </div>
          </div>

          <div class="col-4 pr-0">
            <div class="d-flex form-input-display mg-b-10" *ngIf="deposited || deposited === 0">
              <div class="d-flex d-md-none top-text">
                Deposit
              </div>
              <div class="d-none d-md-flex top-text">
                Deposit required
              </div>
              <div class="input-value deposit-value">
                {{ deposited }}%
              </div>
            </div>
            <div class="d-flex" *ngIf="registrationService.userRole !== userRoleEnum.ReadOnly">
              <button class="btn btn-block btn-buy-now" [ngClass]="{
                'btn-greengo': isGettedRate,
                'btn-inactive': !isGettedRate
              }" (click)="buyNow()" npFocusOutClicked>
                Buy Now
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>